import { fetchApi } from '@/config/axiosSetting';
import { PatchCulpritPropertyInsuranceType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchCulpritPropertyInsurance/patchCulpritPropertyInsurance.type';

export const patchCulpritPropertyInsuranceFunction = ({
  id,
  formData,
}: PatchCulpritPropertyInsuranceType) => {
  return fetchApi.patch(
    `/property/reports/${id}/accident_users/culprit/insurance_information/`,
    {
      ...formData,
    },
  );
};
